import { render } from "./EquipList.vue?vue&type=template&id=64bc600d&scoped=true"
import script from "./EquipList.vue?vue&type=script&lang=js"
export * from "./EquipList.vue?vue&type=script&lang=js"

import "./EquipList.vue?vue&type=style&index=0&id=64bc600d&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bc600d"]])

export default __exports__